Slider =  {

	init : ->
		console.log 'Slider init'
		
		$('*[slick="slide-1"]').slick({
			arrows: false,
		})
		
		
		$('*[slick="fade-blog-with-arrow"]').each ->
			slider = $(this)
			slider.slick({
				arrows: true,
				infinit:true,
				fade:true,
				prevArrow:"",
				nextArrow:slider.parent().find(".control_next")
			})
		
		
		$('*[slick="slide-wAuto"]').each ->
			console.log 'slider width auto init'
			slider = $(this)
			slider.slick({
				arrows: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				variableWidth:true,
				touchThreshold:500,
				appendArrows: slider.parent().find('.nav'),
				prevArrow: '<button type="button" class="slick-prev"><i class="icon-left-open-big"></i></button>',
				nextArrow: '<button type="button" class="slick-next"><i class="icon-right-open-big"></i></button>',
				infinite: false,
				responsive: [
					{
						breakpoint: 1400,
						settings: {
							slidesToShow: 1
						}
					}
				]
			})
		$('*[slick="slide-3"]').each ->
			console.log('slider 3 init')
			slider = $(this)
			slider.slick({
				arrows: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				variableWidth:true,
				touchThreshold:500,
				appendArrows: slider.parent().find('.nav'),
				prevArrow: '<button type="button" class="slick-prev"><i class="icon-left-open-big"></i></button>',
				nextArrow: '<button type="button" class="slick-next"><i class="icon-right-open-big"></i></button>',
				infinite: true,
			})

		$('*[slick="slide-vertical"]').slick({
			vertical: true,
			slidesToShow: 1,
			arrows: false,
			draggable: false
		})
		
		$('*[slick="fade-auto-arrow"]').each ->
			console.log('slider fade-auto-arrow init')
			slider = $(this)
			slider.slick({
				arrows: true,
				appendArrows: slider.parent().find('.nav'),				
				prevArrow: '<button type="button" class="slick-prev"><i class="icon-left-open-big"></i></button>',
				nextArrow: '<button type="button" class="slick-next"><i class="icon-right-open-big"></i></button>',
				fade: true,
				autoplay: true,
				autoplaySpeed: 2500,
			})

		

		if Config.isMobile()

			$('*[slick="mobile-3"]').slick({
				slidesToShow: 3,
				slidesToScroll: 3,
				arrows: false,
				dots: true,
				infinite: false,
			})

			$('*[slick="mobile-1"]').slick({
				slidesToShow: 1.1,
				arrows: false,
				dots: false,
				infinite: false,
			})

			$('*[slick="mobile-home"]').slick({
				slidesToShow: 1.2,
				arrows: false,
				dots: false,
				infinite: false,
			})

			$('*[slick="mobile-dots"]').slick({
				slidesToShow: 1,
				arrows: false,
				dots: true,
				infinite: false,
			})

			$('*[slick="fade"]').slick({
				arrows: false,
			})
			
			$('*[slick="mobile-appart"]').slick({
				slidesToShow: 1,
				centerMode: true, 
				arrows: false,
				dots: false,
			})
		else
			$('*[slick="fade"]').slick({
				arrows: false,
				fade: true,
				autoplay: false,
				autoplaySpeed: 3000,
			})
			$('*[slick="fade-auto"]').slick({
				arrows: false,
				fade: true,
				autoplay: true,
				autoplaySpeed: 3000,
			})
			
			@fixSlidersHeight()

		@controlsManager()


	fixSlidersHeight : ->

		setTimeout ->
			# Slider "Besoins" sur page Villa
			$('#section-besoins .slider-container').height($('#section-besoins .cols--txt').outerHeight())
			$('#section-besoins .slick-slide').height($('#section-besoins .cols--txt').outerHeight())
			
		, 700

		$(window).on "resize", (ev) ->
			$('#section-besoins .slider-container').height($('#section-besoins .cols--txt').outerHeight())
			$('#section-besoins .slick-slide').height($('#section-besoins .cols--txt').outerHeight())

	
	controlsManager : ->

		eltOpacity = $('.slider-container .control_next .control--nb').css('opacity')

		# Show arrow on hover 
		$('.slider-container .controls-container').on "mouseenter", (ev) ->
			if not $(@).hasClass('active')
				_this = @
				controlNextElt = $(@).find('.control_next')
				
				tlShowArrow = new TimelineLite
				tlShowArrow.addLabel('start')
					.to(controlNextElt.find('.control--nb'), 0.3, {autoAlpha:0, ease:Expo.easeOut}, 'start')
					.to(controlNextElt.find('.control--arrow'), 0.4, {x:'0%', ease:Back.easeOut}, 'start')
					.add ->
						$(_this).addClass('active')

		# Hide arrow on mouse leave
		$('.slider-container .controls-container').on "mouseleave", (ev) ->
			if $(@).hasClass('active')
				_this = @
				controlNextElt = $(@).find('.control_next')

				tlHideArrow = new TimelineLite
				tlHideArrow.to(controlNextElt.find('.control--arrow'), 0.4, {x:'100%', ease:Back.easeIn})
					.to(controlNextElt.find('.control--nb'), 0.3, {autoAlpha:eltOpacity, ease:Expo.easeIn})
					.add ->
						$(_this).removeClass('active')
				
		# Change slide on click
		$('.slider-container .controls-container').on "click", (ev) ->
			
			slider = $(@).parents('.slider-container').find('[slick]')

			# trigger slide change
			slider.slick('slickNext')

			# Update slide number
			sliderNbElt = $(@).parents('.slider-container').find('.control_prev .control--nb')

			currentSlideNb = slider.slick('slickCurrentSlide') + 1

			# Add 0 at the start if currentSlideNb < 10
			if currentSlideNb.toString().length < 2
				currentSlideNb = "0" + currentSlideNb

			tlUpdateSlideNb = new TimelineLite
			tlUpdateSlideNb.addLabel('start')
				.fromTo(sliderNbElt, 0.3, {y:'-50%', autoAlpha:1}, {y:'-100%', autoAlpha:0, rotationX:'-90deg', ease:Back.easeOut})
				.add ->
					sliderNbElt.html(currentSlideNb)
				.set(sliderNbElt, {y:'0%', rotationX:'90deg'})
				.to(sliderNbElt, 0.3, {y:'-50%', autoAlpha:1, rotationX:0, ease:Expo.easeOut})

		# Update slide number on swipe
		$('[slick]').on 'beforeChange', (event, slick, direction) ->
			
			sliderContainer = slick.$slider.parents('.slider-container')
			sliderNbElt = sliderContainer.find('.control_prev .control--nb')
			currentSlideNb = slick.$slider.slick('slickCurrentSlide') + 1

			# Add 0 at the start if currentSlideNb < 10
			if currentSlideNb.toString().length < 2
				currentSlideNb = "0" + currentSlideNb
			
			tlUpdateSlideNb = new TimelineLite
			tlUpdateSlideNb.addLabel('start')
				.fromTo(sliderNbElt, 0.3, {y:'-50%', autoAlpha:1}, {y:'-100%', autoAlpha:0, rotationX:'-90deg', ease:Back.easeOut})
				.add ->
					sliderNbElt.html(currentSlideNb)
				.set(sliderNbElt, {y:'0%', rotationX:'90deg'})
				.to(sliderNbElt, 0.3, {y:'-50%', autoAlpha:1, rotationX:0, ease:Expo.easeOut})

	destroy : ->
		console.log "Slider destroy"
		
}